<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <!-- {{  studentList }} -->

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div
          v-if="this.userSelectList != 0"
          class="flex flex-wrap md:items-center md:justify-end gap-3 md:gap-5 pt-10 px-10"
        >
          <button
            class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm"
            @click="this.popupMailAll = true"
          >
            Send Mails
          </button>
          <button
            class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm"
            @click="this.popUpAll = true"
          >
            Send Notifications
          </button>
          <button
            class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center"
            @click="userdeownload"
            :disabled="isDownload"
          >
            <span v-if="!isDownload">Download</span>
            <span v-else class="flex items-center gap-2">
              <svg
                class="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                ></path>
              </svg>
              Download...
            </span>
          </button>
        </div>

        <div class="flex justify-end w-full px-10 py-5">
          <div class="relative">
            <form @submit.prevent="getstudentdetails(1)">
              <input
                type="text"
                placeholder="Search"
                id="search"
                v-model="searching"
                @input="getstudentdetails(1)"
                class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
              />
              <button type="submit" class="">
                <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                  <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                </div>
              </button>
            </form>
          </div>
        </div>
        <div
          class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
          v-if="response_message"
        >
          <h2 class="text-blues text-center">
            {{ response_message }}
          </h2>

          <router-link
            :to="{ name: 'DownloadHistory' }"
            class="text-blue-600 text-xs underline font-bold"
          >
            Download History
          </router-link>
        </div>
        <div class="w-full overflow-x-auto">
          <table class="table-auto w-full">
            <thead>
              <tr>
                <th
                  class="p-4 border-b border-t text-center text-blues whitespace-nowrap"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </th>

                <th
                  class="p-4 border text-center text-blues whitespace-nowrap"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  S NO
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Name
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Email
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Last login
                </th>

                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  IP Address
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Batch
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Program
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Department
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  USN
                </th>

                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Account Created
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Progress
                </th>
                <th
                  class="p-4 border text-center text-blues"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Percentage
                </th>

                <th
                  class="p-4 border text-center text-blues whitespace-nowrap"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Mail to
                </th>
              </tr>
            </thead>
            <tbody
              v-if="loading"
              style="height: calc(100vh - 350px) !important"
            >
              <tr class="w-full">
                <td colspan="15" class="text-center py-6">
                  <div class="flex items-center justify-center">
                    <img src="@/assets/newd/loading.gif" alt="" />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody
              v-else-if="studentList && studentList.length > 0 && !loading"
            >
              <tr v-for="(el, index) in this.studentList" :key="el">
                <td class="p-4 border-b text-center border-r">
                  <!-- <p class="text-primary">{{ index + 1 }}</p> -->
                  <input
                    type="checkbox"
                    :value="el.id"
                    v-model="userSelectList"
                    name=""
                    id=""
                  />
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary">
                    {{ (currentPage - 1) * 10 + index + 1 }}
                  </p>
                </td>
                <td class="p-4 border-b text-center border-r whitespace-nowrap">
                  <p v-if="el.display_name" class="text-primary">
                    {{ el.display_name }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary">{{ el.email }}</p>
                </td>
                <td class="p-4 border-b text-center border-r whitespace-nowrap">
                  <p class="text-primary">
                    {{
                      new Date(el.last_in).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    }}
                    -
                    {{ new Date(el.last_in).toLocaleTimeString("en-IN") }}
                  </p>
                </td>

                <td class="p-4 border-b text-center border-r">
                  <p v-if="el.ip_address" class="text-primary">
                    {{ el.ip_address }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p v-if="el?.profile_data?.batch?.year" class="text-primary">
                    {{ el.profile_data.batch.year }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p
                    v-if="el?.profile_data?.program?.name"
                    class="text-primary"
                  >
                    {{ el.profile_data.program.name }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p
                    v-if="el?.profile_data?.department?.name"
                    class="text-primary"
                  >
                    {{ el.profile_data.department.name }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p v-if="el?.profile_data?.usn" class="text-primary">
                    {{ el.profile_data.usn }}
                  </p>
                  <p v-else class="text-primary">NA</p>
                </td>

                <td class="p-4 border-b text-center border-r whitespace-nowrap">
                  <p class="text-primary">
                    {{
                      new Date(el.lms_joined_date).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    }}
                    -
                    {{
                      new Date(el.lms_joined_date).toLocaleTimeString("en-IN")
                    }}
                  </p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary">
                    {{ el.completed_lessons_count }}/{{
                      el.total_lessons_count
                    }}
                  </p>
                </td>
                <td class="p-4 border-b text-center border-r">
                  <p class="text-primary">{{ el.completion_percentage }}</p>
                </td>

                <td class="p-4 border-b text-center">
                  <div
                    class="w-full flex items-center justify-center"
                    @click="
                      popUp = true;
                      this.mailid = el;
                    "
                  >
                    <img
                      src="@/assets/newd/mail.png"
                      class="text-center cursor-pointer"
                      alt=""
                    />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="w-full">
                <td colspan="15" class="text-center py-6">
                  <div class="w-full flex justify-center items-center">
                    No Data Found
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          v-if="totalPages > 1"
          :totalPages="totalPages"
          ref="paginationRef"
          @page-changed="getstudentdetails"
        />
      </div>

      <!-- <div class="">  
            <div class="flex w-full pt-10">
                <div class="flex rounded-2xp-4box-shadow: 0px 2px 30px 0px #01B0F926;"> 
                    <table clas="table-autop-4
                        <thead> p-4
                            <tr>p-4
                                <th class="p-4 text-center border-r">S NO</th>
                                <th class="p-4 text-center border-r">Name</th>
                                <th class="p-4 text-center border-r">Email</th>
                                <th class="p-4 text-center border-r">Last login</th>
                                <th class="p-4 text-center">Mail to </th>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> -->

      <div
        v-if="popUp"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">New Message</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popUp = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailref"
                  @submit.prevent="sendmail"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="flex">
                    <p
                      class="bg-blues text-white font-semibold text-sm px-4 py-1 rounded-xl"
                    >
                      {{ this.mailid.display_name }}
                    </p>
                  </div>

                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border-b rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="this.popUpAll"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Send Notifications</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popUpAll = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailrefbulk"
                  @submit.prevent="sendmailNotifications"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="this.popupMailAll"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Send Mails</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popupMailAll = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailrefbulkmail"
                  @submit.prevent="sendmailMails"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="files"
                        type="file"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],
      popUpAll: false,
      popupMailAll: false,
      popUp: false,
      minimize: true,
      maximize: false,
      studentList: [],
      mailid: null,
      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      searching: "",
      isDownload: false,
      currentPage: 1,
      totalPages: 1,
      pageArray: [],
      selectAll: false,
      studentAllList: [],
      response_message: "",
    };
  },
  created() {
    this.getAllstudentdetails();
    this.getstudentdetails(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    userSelectList() {
      this.selectAll =
        this.userSelectList.length === this.studentAllList.length;
    },
  },

  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.userSelectList = this.studentAllList.map((x) => x.id);
      } else {
        this.userSelectList = [];
      }
    },
    async sendmailNotifications() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/user/notifications/?Key=${this.userInfo.token_key}`,
          {
            topic: document.getElementById("subject").value,
            message: document.getElementById("content").value,
            user_id: this.userSelectList,
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            this.$refs.mailrefbulk.reset();
            this.popUpAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async sendmailMails(el) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/email_sent_selected_student/?Key=${this.userInfo.token_key}`,
          {
            topic: document.getElementById("subject").value,
            message: document.getElementById("content").value,
            user_id: JSON.stringify(this.userSelectList),
            attachments: el.target.elements.files.files[0],
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            this.$refs.mailrefbulkmail.reset();
            this.popupMailAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async getAllstudentdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/all_list/${this.course_id}/?Key=${this.userInfo.token_key}&search=${this.searching}`
        )
        .then((response) => {
          console.log(response);
          this.studentAllList = response.data.data || [];
          // this.loading = false;
        });
    },
    async getstudentdetails(page = 1) {
      this.currentPage = page;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/all_list/students/${this.course_id}/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}`
        );

        console.log(response);

        this.totalPages = response.data.total_page || 1;
        this.studentList = response.data.data || [];
      } catch (error) {
        console.error("Error fetching student details:", error);
        this.studentList = [];
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    async sendmail(event) {
      const HeaderVal = {
        subject: event.target.elements.subject.value,
        time: "",
        content_1: event.target.elements.content.value,
        content_2: "",
        content_3: "",
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/user/notifications/?Key=${this.userInfo.token_key}`,
          {
            topic: event.target.elements.subject.value,
            message: event.target.elements.content.value,
            user_id: [this.mailid],
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      this.$refs.mailref.reset();
      this.popUp = false;
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },

    async sendmailallStudnt() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/instructor_send_student/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          if (Response.message == "successfully Email send") {
            this.messages = {
              text: "Mail Sent successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },
    async userdeownload() {
      if (this.isDownload) return;
      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/download_student_liist/?Key=${this.userInfo.token_key}`,
          {
            course_id: this.course_id,
            user_id: this.userSelectList,
          }
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
            this.userSelectList = [];
          }, 5000);
        } else {
          this.messages = {
            text: "Event Failed",
            type: "error",
          };
          console.log("not successful");
        }
      } catch (error) {
        console.error("Delete error:", error);
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "" };
        }, 2500);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
